import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as actions from '../redux/marketingBanner';
import { actions as errorActions } from '@dragonfruit/redux/error';

import { apiGetMarketingBanner } from '../services/apis';

export function* fetchMarketingBanner(action) {
  const { locale, region } = action.payload;
  try {
    const response = yield call(apiGetMarketingBanner, {
      region,
    });

    const {
      banners: [banner = {}],
    } = response.data;

    const { url: link = '', contentI18n = {}, urlTagI18n = {} } = banner;

    const bannerContent = contentI18n[locale] || contentI18n.en || '';
    const bannerUrl = urlTagI18n[locale] || urlTagI18n.en || '';

    yield put(
      actions.fetchMarketingBannerSuccess({
        content: bannerContent,
        url: bannerUrl,
        link,
      })
    );
  } catch (err) {
    yield put(actions.fetchMarketingBannerError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([takeLatest(actions.FETCH_MARKETING_BANNER, fetchMarketingBanner)]);
}



// WEBPACK FOOTER //
// ./app/sagas/marketingBanner.js